<template>
<div class="w-full flex flex-col justify-center items-center z-30 bg-dark-primary text-white ">
  <div class="z-50 flex w-full items-center justify-center" :class="{ 'border-b border-white' : visibleNavDropdown || nestedNavLinks }">
    <div class="flex justify-between items-center w-full h-16 overflow-clip">
      <div class="flex w-fit items-center space-x-4">
            <NavLink
              :link="{ path: '/', label: 'Home'}"
              @track-link-selection="logLinkSelection"
            >
            <div class="flex items-center ml-8 pr-4 border-r-2 border-white">
              <div class="text-lg whitespace-nowrap">
                Aerocle
              </div>
              <!-- <div class="text-xs whitespace-nowrap">
                Powered by:
              </div>
              <shedd-logo class="h-28 cursor-pointer" /> -->
            </div>
          </NavLink>
          <div class="whitespace-nowrap pt-0.5">
           {{ pageTitle }}
          </div>
      </div>
      <div v-if="windowWidth > navBreakpoint" class="flex justify-end items-center space-x-6 w-full h-full pr-10">
        <!-- <nav-link
          v-for="(navLink, index) in navLinks"
          :key="index"
          :link="navLink"
          @select-nested-links="selectNestedNavLinks"
          @clear-nested-links="clearNestedNavLinks"
        /> -->
      </div>
      <div v-else class="pr-6 flex items-center">
        <button class="w-6 h-6 flex justify-center items-center cursor-pointer border-b-2 border-dark-primary hover:border-white ease-in duration-200" ref="navDropdownBoundary">
          <TransitionGroup name="hamburger-menu">
            <hamburger-menu v-if="!visibleNavDropdown" color="white" @click="showNavDropdown" />
            <close-x v-else color="white" @click="hideNavDropdown" />
            </TransitionGroup>
        </button>
      </div>
    </div>
  </div>
  <Transition
    class="duration-200 ease-out"
    enter-from-class="transform translate-x-[100%] opacity-0"
    leave-to-class="transform  translate-x-[100%] opacity-0"
    key="nav-dropdown"
  >
    <div v-if="visibleNavDropdown" class="flex overflow-clip flex-col space-y-4 w-full items-end pr-6 py-4 bg-dark-primary">
      <!-- <nav-link
          v-for="(navLink, index) in dropdownNavLinks"
          :key="index"
          :link="navLink"
        /> -->
    </div>
  </Transition>
  <Transition
    class="duration-200 ease-out"
    enter-from-class="transform translate-x-[100%] opacity-0"
    leave-to-class="transform  translate-x-[100%] opacity-0"
    key="nested-nav-links"
  >
    <div v-if="nestedNavLinks" class="flex overflow-clip flex-col space-y-4 w-full items-end pr-6 py-4 bg-dark-primary" :class="{ 'pr-10' : windowWidth > navBreakpoint }">
      <!-- <nav-link
          v-for="(navLink, index) in nestedNavLinks"
          :key="index"
          :link="navLink"
        /> -->
    </div>
  </Transition>
</div>

</template>

<script setup>
import { ref, computed, onMounted, onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import SheddLogo from '@/components/svg-components/SheddLogo.vue';
import HamburgerMenu from '@/components/svg-components/HamburgerMenu.vue';
import CloseX from '@/components/svg-components/CloseX.vue';
import NavLink from '@/components/nav-bar-link-components/NavLink.vue';
import { createPageVisitLog } from '@/services/PageVisitLog';
import { useClickOutside } from '@/composables/useClickOutside';
import BreadCrumb from '@/components/BreadCrumb.vue';

const store = useStore()
const route = useRoute()

const navBreakpoint = ref(1024) // 768
const nestedNavLinks = ref(null)
const windowWidth = ref(window.innerWidth)
const visibleNavDropdown = ref(false)
const navDropdownBoundary = ref(null)
const xPosition = ref(0)
const yPosition = ref(0)
const previousTitle = ref('')
const currentTitle = ref('')

const navLinks = ref([
  // {
  //   path: "/",
  //   label: 'Home'
  // },
//   {
//     path: "/investment-criteria",
//     label: 'Investment Criteria',
//     class: '',
//   },
//   {
//     path: "/services",
//     label: 'Services',
//     class: '',
//   },
//   {
//     path: "/research-capabilities",
//     label: 'Research Capabilities',
//     class: '',
//   },
//   {
//     path: "/team",
//     label: 'Team',
//     class: '',

//     nestedLinks: [
//       // {
//       //   path: '/team',
//       //   label: 'Team',
//       //   class: 'w-full flex justify-end items-center',
//       // },
//       {
//         path: '/team/internships',
//         label: 'Internships',
//         class: 'w-full flex justify-end items-center',
//       },
//     ]
//   },
//   {
//     path: "/transactions",
//     label: 'Transactions',
//     class: '',
//   },
//   {
//     path: "/contact",
//     label: 'Contact Us',
//     class: '',
//   },

])

const pageTitle = computed(() => {
  return route.meta.pageTitle
})

watch(() => pageTitle.value, () => {
  document.title
})

const dropdownNavLinks = computed(() => {
  let dropdownLinks = []
  for(let navLink of navLinks.value) {
    if(navLink.nestedLinks) {
      dropdownLinks.push({
        path: navLink.path,
        label: navLink.label,
        class: 'w-full flex justify-end items-center'
      })
      for(let nestedNavLink of navLink.nestedLinks) {
        dropdownLinks.push({
          path: nestedNavLink.path,
          label: `${nestedNavLink.label}`,
          icon: 'square',
          class: 'w-full flex justify-end items-center pr-2'
        })
      }
    } else {
      dropdownLinks.push({
        path: navLink.path,
        label: navLink.label,
        class: 'w-full flex justify-end items-center'
      })
    }
  }
  return dropdownLinks
})

onMounted(() => {
  window.addEventListener('resize', onResize)
})

onBeforeMount(() => {
  window.removeEventListener('resize', onResize)
})

useClickOutside(navDropdownBoundary, ()=> {
  hideNavDropdown()
  clearNestedNavLinks()
})

function onResize() {
  windowWidth.value = window.innerWidth
  if(windowWidth.value > navBreakpoint.value) {
    hideNavDropdown()
    clearNestedNavLinks()
  }
  setNavLinkClasses()
}

function showNavDropdown() {
  visibleNavDropdown.value = true
  xPosition.value = navDropdownBoundary.value.getBoundingClientRect().left - 104
  yPosition.value = navDropdownBoundary.value.getBoundingClientRect().bottom
}

function hideNavDropdown() {
  visibleNavDropdown.value = false
  xPosition.value = 0
  yPosition.value = 0
}

function selectNestedNavLinks(nestedLinks) {
  nestedNavLinks.value = nestedLinks
}

function clearNestedNavLinks() {
  nestedNavLinks.value = null
}

function setNavLinkClasses() {
  let navLinkClass
  if(windowWidth.value > navBreakpoint.value) {
    navLinkClass = ''
  } else {
    navLinkClass = 'w-full flex justify-end items-center'
  }
    for(let navLink of navLinks.value) {
      navLink.class = navLinkClass
    }
}

  function logLinkSelection(toPage) {
    console.log('to page', toPage)
    console.log(previousTitle.value, currentTitle.value, toPage)
    previousTitle.value = currentTitle.value
    currentTitle.value = toPage
    document.title = currentTitle.value
    console.log(`log link selection from ${previousTitle.value} => ${toPage}`)
    const token = store.state.auth.token
    let data = JSON.stringify({
      from_page_name: previousTitle.value, 
      to_page_name: toPage
    })
    createPageVisitLog(token, data)
  }

setNavLinkClasses()
</script>

<style scoped>
.hamburger-menu-move,
.hamburger-menu-enter-active {
    transition: all 0.6s ease;
}
.hamburger-menu-leave-active {
  transition: all 0.6s ease;
}
.hamburger-menu-enter-from {
  opacity: 0;
  /* transform: translateY(100%); */
}
.hamburger-menu-leave-to {
  opacity: 0;
  /* transform: translateY(-100%); */
}

.hamburger-menu-leave-active {
    position: absolute;
    /* position: relative; */
}
</style>
